export default {
    namespaced: true,
    state() {
        return {
            course_code: null,
            cities: [],
            editions: [],
            errors: [],
        }
    },
    mutations: {
        setCourseCode(state, courseCode) {
            state.course_code = courseCode
        },
        setCities(state, cities) {
            state.cities = cities
        },
        setEditions(state, editions) {
            state.editions = editions
        },
        setErrors(state, errors) {
            state.errors = errors
        }
    },
    actions: {
        setCourseCode({ commit }, courseCode) {
            commit('setCourseCode', courseCode)
        },
        setCities({ commit }, cities) {
            commit('setCities', cities)
        },
        setEditions({ commit }, editions) {
            commit('setEditions', editions)
        },
        setErrors({ commit }, errors) {
            commit('setErrors', errors)
        }
    }
}
